module.exports = __webpack_public_path__ + "media/images/lb/096-d97c7a60a066b8b8842b9d18533f400e.svg";